/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect,useState } from 'react';
import { azureMapConfig } from '@services/azureMap/config';
import {
  getInfoboxTemplate,
  locationIconRender
} from '@components/findDealer/common.methods';
import { loadAzureMapScript } from '@utils/common';
import {
  ALL,
  AUTO,
  DURATION,
  FLY,
  LIST,
  POSITION,
  ROAD,
  SUBSCRIPTION_KEY,
  LATITUDE_VALUE,
  LONGITUDE_VALUE,
  htmlContent,
  GRAYSCALE_LIGHT
} from '@constants/azureMap';
import { getPartnerIconColor } from '@utils/findPartner';

let dataSource;
let map;
let marker = null;
let popup;
const AzureMaps = ({
  id,
  center,
  mapRef,
  dealerData,
  width = '100%',
  height = '100%'
}) => {
  useEffect(() => {
    loadAzureMapScript()
      .then(() => {
        map = new atlas.Map(id, {
          center: [LONGITUDE_VALUE, LATITUDE_VALUE],
          zoom: 8,
          view: AUTO,
          style: GRAYSCALE_LIGHT,
          authOptions: {
            authType: SUBSCRIPTION_KEY,
            subscriptionKey: azureMapConfig.location.azureMapKey
          }
        });
        if (mapRef && mapRef.current !== undefined) {
          mapRef.current = map;
        }
        map.controls.add(
          new atlas.control.StyleControl({
            mapStyles: ALL,
            layout: LIST,
            style: atlas.control.auto
          }),
          { position: POSITION }
        );
        map.controls.add(
          [
            new atlas.control.ZoomControl(),
            new atlas.control.FullscreenControl(),
          ],
          { position: POSITION }
        );
     
        /*Ready event is used to load the map in to div*/
        map?.events?.add('ready', async () => {
          if (isNotEmpty(dealerData)) {
 
            dataSource = new atlas.source.DataSource();
            moveMapToLocation(center);
            dataSource.add(dealerData);
            map.sources.add(dataSource);
            let shapes = dataSource.getShapes();
            dealerIcon(shapes);
          } else {
            moveMapToLocation(center);
          }
          popup = new atlas.Popup({
            closeButton: false,
            closeOnMouseOut: true,
            pixelOffset: [
              0, -10
            ] /*An array of [pixelsRight, pixelsDown] for how many pixels to the right and down the anchor of the popup should be offset. Negative numbers can be used to offset the popup left and up.*/
          });
        });
      })
      .catch(error => {
        console.error('Error in Loading Maps ' + error);
      });
    return () => {
      if (mapRef?.current && typeof mapRef?.current.dispose === 'function') {
        mapRef?.current.dispose();
      }
    };
  }, [dealerData]);
 
  const dealerIcon = async shapes => {
    const updateD = shapes.map(async (it, index) => {
      const iconId = `custom-icon-${index}`;
      if (it.data?.properties) {
        it.data.properties.icon = iconId;
      }
      let filterBoolean = it.data.properties.active;
      
      let filterColor = getPartnerIconColor(it.data.properties.accountSupType) // Comment out now
      const base65 = locationIconRender(30, filterColor);
      map.imageSprite
        .add(iconId, base65)
        .then(() => {})
        .catch(async e => {
          await console.error(e);
        });
      return it;
    });
    const finalData = await Promise.all(updateD);
 
    dataSource.clear();
    dataSource.add(finalData);
    let searchLayer = new atlas.layer.SymbolLayer(dataSource, null, {
      iconOptions: {
        image: ['get', 'icon'],
        allowOverlap: true
      }
    });
    mapRef?.current.layers.add(searchLayer);
    /*Adds an event to the HtmlMarker(s) to show requied content*/
    mapRef?.current.events.add('mouseenter', searchLayer, async function (e) {
      /*Make sure the event occurred on a shape feature.*/
      if (e.shapes && e.shapes.length > 0) {
        let properties = e.shapes[0].data.properties;
        popup.setOptions({
          position: e.shapes[0].data.geometry.coordinates,
          content: getInfoboxTemplate(properties)
        });
        popup.open(mapRef?.current);
      }
    });
    /*Adds an event to the HtmlMarker(s). */
    mapRef?.current.events.add('mouseover', () => {
      popup.close();
    });
    /*Adds an popup to the HtmlMarker(s). pl check line no. 20 (added basic configuration)*/
    mapRef?.current.popups.add(popup);

  };
 
  const moveMapToLocation = async center => {
    if (mapRef?.current && typeof mapRef?.current.setCamera === 'function') {
      mapRef?.current?.setCamera({
        center: [center[0], center[1]],
        zoom: 8,
        type: FLY,
        duration: DURATION
      });
    } else {
      console.error('setCamera is loaded in Azure Maps');
    }

    if (marker && typeof mapRef?.current?.markers?.remove === 'function') {
      mapRef?.current?.markers?.remove(marker);
    } else {
      await console.error('Error in Removing Markers ');
    }

    /*Adds HTML based markers to the map.*/
    marker = new atlas.HtmlMarker({
      htmlContent: htmlContent,
      position: [center[0], center[1]]
    });
    if (mapRef?.current) {
      mapRef?.current?.markers?.add(marker);
    } else {
      console.error('markers is not Loaded in Azure Maps');
    }
  };
  return (
    <div
      data-testid='test-map'
      id={id}
      ref={mapRef}
      style={{ height: height, width: width }}
    />
  );
};

export default AzureMaps;
function isNotEmpty(data) {
  if (Array.isArray(data)) {
    return data.length > 0;
  } else if (typeof data === 'object' && data !== null) {
    return Object.keys(data).length > 0;
  }
  return false;
}